// Fuente unica de verdad para las fases activas del kanban de pedidos.
// El color siempre deriva de esta lista; el `label` es el valor por defecto
// (el usuario puede personalizarlo visualmente, ver useKanbanPrefs).
export const FASES_PEDIDO = [
  { key: 'pendiente', label: 'Pendiente', color: '#fbbc04' },
  { key: 'en_revision', label: 'En Revision', color: '#FF9500' },
  { key: 'esperando_pago', label: 'Esperando Pago', color: '#9c27b0' },
  { key: 'pago_en_verificacion', label: 'Verif. Pago', color: '#673ab7' },
  { key: 'armado', label: 'Armado', color: '#ff6d00' },
  { key: 'listo', label: 'Listo', color: '#1a73e8' },
  { key: 'en_camino', label: 'En Camino', color: '#00bcd4' },
  { key: 'llegada', label: 'Llegada', color: '#009688' },
];

// Normaliza un estado de pedido a su clave de fase de kanban.
// En empresas importadoras, los pedidos entregados (terminales) se muestran en la
// ultima columna (llegada) como "historial reciente", en lugar de caer a pendiente.
export const faseDeEstado = (estado, esImportador = false) => {
  let est = estado || 'pendiente';
  if (est === 'armado_cocina') est = 'armado';
  if (est === 'despachado') est = 'en_camino';
  if (esImportador && (est === 'entregado' || est === 'credito_pagado')) est = 'llegada';
  return FASES_PEDIDO.some((f) => f.key === est) ? est : 'pendiente';
};

export const colorDeFase = (key) => {
  const f = FASES_PEDIDO.find((x) => x.key === key);
  return f ? f.color : '#1a73e8';
};

export default FASES_PEDIDO;
